import { ToggleGroup } from "@src/ui-kit";
import { useStores } from "@stores";
import { observer } from "mobx-react-lite";
import type React from "react";
import { useState } from "react";
import { Icon } from "../Icon";
import { FavoriteMarketsList } from "./FavoriteMarketsList";
import { DISPLAY_OPTIONS } from "./constants";
import { Container } from "./styles";
import type { DisplayMode } from "./types";

export const FavoriteMarkets: React.FC = observer(() => {
  const { marketStore } = useStores();
  const [displayMode, setDisplayMode] = useState<DisplayMode>("price");

  return (
    <Container data-testid="favorite-markets">
      <Icon data-testid="favorite-markets:icon" color="yellow-strong" icon="ri-star-fill" size="16px" />
      <ToggleGroup
        data-testid="favorite-markets:display-toggle"
        options={DISPLAY_OPTIONS}
        size="sm"
        value={displayMode}
        onChange={setDisplayMode}
      />

      <FavoriteMarketsList
        addresses={marketStore.favoriteMarketAddresses.slice()}
        allMarkets={marketStore.allMarkets}
        displayMode={displayMode}
        onMarketClick={marketStore.setActiveMarket}
      />
    </Container>
  );
});
